const Role = {
  Admin: 'Administrator',
  User: 'User',
}

export default Role;